import script from "./CTournamentLaurel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentLaurel.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentLaurel.vue?vue&type=style&index=0&id=0c96dc12&lang=less"

const __exports__ = script;

export default __exports__